<template>
  <nd-dialog
    v-model="visible"
    close-btn
    :footer="false"
    title="大权益支付"
  >
    <div class="pay-content">
      <div class="pay-info">
        您存在未支付的消费订单，请先支付完成后才可发起提现！
      </div>
      <nd-button
        class="pay-btn"
        @click="handleToPay"
      >去支付</nd-button>
    </div>
  </nd-dialog>
</template>

<script>
export default {
  name: 'vvipIntroDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    repayBillNo: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
    }
  },
  computed: {
    visible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    // 跳转去支付
    handleToPay () {
      this.$router.push(`/repayment/detail-expense?repayBillNo=${this.repayBillNo}`)
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.pay-content{
  padding: 30px 50px;
  text-align: center;
  .pay-info{
    font-size: 28px;
  }
  .pay-btn{
    width: 100%;
    margin-top: 100px;
  }
}
</style>